import React from 'react';

function Container({ children }) {
  return <div className="container mx-auto p-4 inner-wrapper">{children}</div>;
}

export { Container };
